import React, { useState } from 'react'
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps'

import mapStyles from './mapStyle'

function Map() {
  const [selectedPlace, setSelectedPlace] = useState(null)
  return (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: 50.08444, lng: 19.10356 }}
      defaultOptions={{ styles: mapStyles }}
    >
      <Marker
        position={{ lat: 50.08444, lng: 19.10356 }}
        onClick={() => {
          setSelectedPlace(true)
        }}
      />

      {selectedPlace && (
        <InfoWindow
          position={{ lat: 50.08444, lng: 19.10356 }}
          onCloseClick={() => {
            setSelectedPlace(null)
          }}
        >
          <div>
            <h5>Wojciech Jagsz</h5>
            <h6>Zakład kominiarski</h6>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  )
}

const WrappedMap = withScriptjs(withGoogleMap(Map))

export default WrappedMap
